// extracted by mini-css-extract-plugin
export default {"root":"root__wWMcbKlG","truncatedDataDownloadText":"truncated-data-download-text__eHByhkTf"};